import { render, staticRenderFns } from "./FormPage4.vue?vue&type=template&id=b72b1ec8&scoped=true&"
import script from "./FormPage4.vue?vue&type=script&lang=js&"
export * from "./FormPage4.vue?vue&type=script&lang=js&"
import style0 from "./FormPage4.vue?vue&type=style&index=0&id=b72b1ec8&scoped=true&lang=css&"
import style1 from "./FormPage4.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72b1ec8",
  null
  
)

export default component.exports